module.exports = __webpack_public_path__ + "img/收纳.0f1b78b4.webp";